import zipObjectDeep from 'lodash/zipObjectDeep'

export default ({ details }) => {
  const violations = details && details.violations && details.violations

  if (violations) {
    if (Array.isArray(violations)) {
      return violations.reduce((acc, violation) => {
        Object.assign(acc, {
          [violation.path.replace(/(^\[|\]$)/g, '')]: violation.message
        })
        return acc
      }, {})
    } else {
      if (violations.path && violations.message) {
        return zipObjectDeep([violations.path], [violations.message])
      }

      if (violations.message) {
        return { _error: violations.message }
      }
    }
  }

  return { _error: 'Неизвестная ошибка' }
}
